import { Pipe, PipeTransform } from "@angular/core";
import { TipoEnviosEnum } from "@shared/enums";

@Pipe({
    name: "nombreLargoTipoEnvio"
})
export class NombreLargoTipoEnvioPipe implements PipeTransform {

    transform(tipoEnvio: TipoEnviosEnum): string {
        switch (tipoEnvio) {
        case TipoEnviosEnum.STICKY_ENGAGE:
            return "ENGAGE";
        case TipoEnviosEnum.QMP:
            return "QMP";
        case TipoEnviosEnum.STICKY_ALWAYS_ANYTIME:
            return "SIEMPRE";
        case TipoEnviosEnum.STICKY_DAY_DAYTIME:
            return "DIARIA HORA";
        case TipoEnviosEnum.STICKY_SINGLE_DAY:
            return "DÍA";
        case TipoEnviosEnum.NOT_STICKY_DATETIME:
            return "EVENTUAL";
        case TipoEnviosEnum.STICKY_WEEK_DAY:
            return "SEMANAL DIA";
        case TipoEnviosEnum.STICKY_WEEK_DAYTIME:
            return "SEMANAL HORA";
        }
    }

}
